module.exports = __webpack_public_path__ + "assets/img/ru-4101babe.png";